import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "./index";
import CRUDcambio from "./CRUDcambio";
import add from "./img/add.png";
import { bkCabGrilla, clCabGrilla, bkCeldaGrilla, clCeldaGrilla, sizeCelda, bkSeleccion, sizeCabezal, bbottomGrilla } from "./general"

export default function Cambios({ filtro }) {
  let { firebase } = useContext(AppContext);
  if (!filtro) filtro = "Todos"
  const [crudCambio, setCrudCambio] = useState(false);
  const [cambio, setCambio] = useState(null);

  useEffect(() => {
    document.getElementById("htmlTituloPagS").innerHTML = "Cambios";
  }, []);

  return (
    <div style={SadmCambios}>
      <div style={Scambios}>
        <div style={Scabezal}><div>Cambios</div><div>Estado</div><div>Id</div></div>
        <div style={SlistaCambios}>
          {firebase.cambios(firebase.proyectoActivo.proyecto.id, filtro).map((c) => (
            <div
              style={SdetalleCambio}
              key={c.id}
              onMouseEnter={(e) => (e.currentTarget.style.background = bkSeleccion)}
              onMouseLeave={(e) => (e.currentTarget.style.background = bkCeldaGrilla)}
              onClick={() => {
                setCambio(c);
                setCrudCambio(!crudCambio);
              }}
            >
              <div style={Scelda}>{c.descripcion.substr(0, 190)}</div>
              <div style={Scelda}>
                {c.estado === "pendiente" ? (
                  <i className="material-icons icono20">alarm_on</i>
                ) : c.estado === "cerrado" ? (
                  <i className="material-icons icono20">done</i>
                ) : c.estado === "no aprobado" ? (
                  <i className="material-icons icono20">block</i>
                ) : c.estado === "aprobado" ? (
                  <i className="material-icons icono20">offline_pin</i>
                ) : (
                          <i className="material-icons icono20">help</i>
                        )}
              </div>
              <div style={Scelda}>{c.id}</div>
            </div>
          ))}
        </div>
        <div style={Sadd}>
          <img
            src={add}
            alt="+"
            title="Agregar"
            height="30px"
            width="30px"
            style={{ display: "block", cursor: "pointer", marginTop: "10px" }}
            onClick={() => {
              setCambio(null);
              setCrudCambio(!crudCambio);
            }}
          ></img>
        </div>
      </div>
      <div style={Scrud}>
        {crudCambio && <CRUDcambio cambio={cambio} set={setCrudCambio} />}
      </div>
    </div>
  );
}

const SadmCambios = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  width: "93.5vw",
  marginTop: "15px"
}

const Scambios = {
  width: "53%",
}

const Scrud = {
  width: "38%",
}

const Scabezal = {
  display: "grid",
  gridTemplateColumns: " 78% 10% 12%",
  background: bkCabGrilla,
  color: clCabGrilla,
  fontSize: sizeCabezal,
  fontWeight: 700,
  padding: "8px 0px 8px 3px",
};

const SlistaCambios = {
  overflowY: "auto",
  maxHeight: "70vh",
  marginTop: "6px",
  cursor: "pointer"
};

const SdetalleCambio = {
  display: "grid",
  gridTemplateColumns: " 78% 10% 12%",
  height: "6.8vh",
  marginBottom: "2px",
  background: bkCeldaGrilla,
  overflow: "hidden"
};

const Scelda = {
  borderBottom: bbottomGrilla,
  padding: "5px 2px 5px 2px",
  fontSize: sizeCelda,
  color: clCeldaGrilla
};

const Sadd = {
  display: "flex",
  justifyContent: "flex-start",
};
